import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AvatarService {
  private gradients: string[] = [
    'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
    'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
    'linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)',
    'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
    'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
  ];

  generateInitials(name: string): string {
    if (!name) return '?';

    const parts = name
      .trim()
      .split(' ')
      .filter((p) => p.length > 0);

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  getRandomGradient(): [string, string] {
    const hue = Math.floor(Math.random() * 360);
    const saturation = 65 + Math.random() * 15; // 65–80%
    const lightness1 = 45 + Math.random() * 10; // 45–55%
    const lightness2 = lightness1 + 10;

    const color1 = `hsl(${hue}, ${saturation}%, ${lightness1}%)`;
    const color2 = `hsl(${(hue + 30) % 360}, ${saturation}%, ${lightness2}%)`;

    return [color1, color2];
  }

  generateAvatarSvg(name: string, size = 64): string {
    const initials = this.generateInitials(name);
    const [color1, color2] = this.getRandomGradient();
    // console.log(color1, color2, 'colors');
    return `
    <svg
      width="${size}"
      height="${size}"
      viewBox="0 0 ${size} ${size}"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="${color1}" />
          <stop offset="100%" stop-color="${color2}" />
        </linearGradient>
      </defs>

      <rect
        width="${size}"
        height="${size}"
        rx="${size / 8}"
        ry="${size / 8}"
        fill="url(#grad)"
      />

      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        dominant-baseline="middle"
        font-family="Arial, sans-serif"
        font-size="${size / 2}"
        fill="#ffffff"
        font-weight="600"
      >
        ${initials}
      </text>
    </svg>
  `;
  }

  getAvatarDataUrl(name: string, size = 64): string {
    // console.log(name, size, 'name & size');
    const svg = this.generateAvatarSvg(name, size);
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }
}
